export var templateParser = function templateParser(str, vars) {
  return str.replace(/{{(\w+)}}/g, function (_, match) {
    return vars[match];
  });
};